import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactusComponent } from './contactus/contactus.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
// import { AuthService } from './services/auth-guard/auth-guard.service';


const routes: Routes = [

  { path:'', pathMatch:"full", redirectTo:'/auth/login'},
  {path:'contact',component:ContactusComponent},
  {path:'privacypolicy',component:PrivacypolicyComponent},
  { path: 'auth',    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
